// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3zTXm","left":"StickyBox_left__36pCI","right":"StickyBox_right__3ho2M"};